/**
 * 组图发布（编辑）
 * */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal, Divider, Input, Icon} from "antd";
import MosaicReleaseImage from "./components/mosaicReleaseComponent/MosaicReleaseImage";
import {red} from "react-color/lib/helpers";
import UploadPreviewImage from "./components/uploadPreviewImage/UploadPreviewImage";
import ImgUpload from "../../../sysManagement/paramConfiguration/configEditModal/components/ConfigValue/ImgUpload/ImgUpload";
const { TextArea } = Input;
const informationSetting={
    labelKey: 'label',//数据保存标题key
    labelName: '标签',//标签名称
    labelPlaceholder: '请输入标签名',//标签的提示
    labelRequest: false,//是否必输项，
    labelMaxlength: 20,//最大输入长度,
    labelDisable: false,//false  不可输入
}
const allowClear= true;
class ImageRelease extends Component {
    constructor(props) {
        super(props);
        this.state={
            editData:{
                ico: {
                    value: '',
                    placeholder: "选择上传图标"
                },
            },
            value:'',
            labelInputVal:'',
            information: {
                title: '',//标题
                label: [],//标签
            },
        }
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                {this.renderImageReleaseModal()}
            </div>
        );
    }

    renderImageReleaseModal=()=>{
        let height=window.innerHeight-102-102;
        let width=window.innerWidth-360-360;
        const {imageReleaseVisible,handleOk,handleCancel} = this.props;
        return(
            <div>
                <Modal
                    centered={true}
                    title="组图发布"
                    visible={imageReleaseVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    bodyStyle={{height}}
                    width={width}
                    okText="发布"
                >
                    <Button type={'primary'} style={{marginLeft:40}}>添加图片</Button>
                    {/*图片组件*/}
                    <MosaicReleaseImage/>
                    <div style={{}}>
                        <Divider />
                        {/*标题输入框*/}
                        {this.renderTitle()}
                        {/*预览图*/}
                        {this.renderPreview()}
                        {/*内容摘要*/}
                        {this.renderSynopsis()}
                        {/*标签*/}
                        {this.renderLabel()}
                    </div>
                </Modal>
            </div>
        )
    }
    //标题输入框
    renderTitle=()=>{
        return (
            <div style={{display: 'flex',marginLeft:62,marginRight:39.75}}>
                <div style={{display: 'flex',width:48}}>
                    <p style={{color: 'red',}}>*</p>{" "}
                    <p>标题 :</p>
                </div>
                <Input placeholder="请输入关键字" style={{background:'#eef2fb'}}  allowClear={allowClear}/>
            </div>
        )
    }
    //预览图
    renderPreview=()=>{
        let {editData}=this.state;
        return(
            <div style={{display: 'flex',marginLeft:52,paddingTop:24}}>
                <div style={{width:56}}>预览图 :</div>
                <UploadPreviewImage
                    placeholder={editData.ico.placeholder}
                    onChange={ico =>this.onDataChange({ ico })}
                    value={editData.ico.value}
                />
            </div>
        )
    }
    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };
    //内容摘要
    renderSynopsis=()=>{
        let {value}=this.state;
        return(
            <div style={{display:'flex',marginLeft:40,marginTop:24,marginRight:39.75}}>
                <div style={{width:75}}>内容摘要 :</div>
                <TextArea
                    style={{ resize: 'none',background: '#eef2fb'}}
                    value={value}
                    onChange={this.onChange}
                    placeholder="请输入关键字"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                />
            </div>
        )
    }
    onChange = ({ target: { value } }) => {
        this.setState({ value });
    };
    //标签
    renderLabel=()=>{
        let {labelInputVal,information}=this.state;
        return(
            <div style={{display:'flex',marginLeft:62,paddingTop:24}}>
                <p style={{width:42}}>标签 :</p>
                <Input style={{width: 251,display: 'inline-block',flex:'unset',backgroundColor:'#eef2fb'}}
                       placeholder={informationSetting.labelPlaceholder}
                       disabled={informationSetting.labelDisable}
                       maxLength={informationSetting.labelMaxlength}
                       onChange={(e) => {
                           this.setState({labelInputVal: e.target.value});
                       }} value={labelInputVal}
                       allowClear={allowClear}
                />
                <Button icon="plus"
                        style={{
                            width: 32,
                            lineHeight: '17px',
                            margin: '0 10px',
                            color: '#595a5b',
                            display: 'inline-block',
                        }}
                        onClick={() => {
                            if (!information.label.includes(labelInputVal) && labelInputVal) {
                                let newLabelArr = [...information.label, labelInputVal];
                                this.setData('label', newLabelArr)
                            }
                        }}
                />
                {information.label.length > 0 ?
                    information.label.map(item => (
                        <div key={item}
                             style={{
                                 display: 'flex',
                                 padding: '0 8px',
                                 width: 'auto',
                                 margin: '0px 8px 0px 0px',
                                 border: '1px solid #dcdcdc',
                                 borderRadius: '5px',
                                 alignItems: 'center',
                                 justifyContent: 'center'
                             }}>
                            <div>
                                {item}
                            </div>
                            <div>
                                <Icon type="close"
                                      onClick={() => {
                                          information.label = information.label.filter(label => label !== item);
                                          console.log('information.label     ', information.label);
                                          this.setState({});
                                      }}
                                      style={{
                                          marginLeft: 8,
                                          fontSize: 12,
                                          cursor: 'pointer',
                                          color: '#afafaf',
                                      }}/>
                            </div>

                        </div>
                    ))
                    : null
                }
            </div>
        )
    }
    // 输入框改变赋值
    setData(key, val) {
        this.state.information[key] = val;
        this.setState({},()=>{
            console.log('this.state.information',this.state.information)
        });
    };
}

ImageRelease.propTypes = {};

export default ImageRelease;